import React, { Dispatch, SetStateAction, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { deleteSupplierBrand, toastSuccess } from '../../../api'
import { TooltipWrapper } from '../../common'
import { SupplierBrand } from '../../../models'
import { getAuthUser } from '../../../helpers'
import defineAbilityFor from './defineAbility'

interface DeleteSupplierBrandProps {
    setIsDeleting: Dispatch<SetStateAction<boolean>>
    supplierBrand: SupplierBrand
}

export const DeleteSupplierBrand = (props: DeleteSupplierBrandProps) => {
    const { setIsDeleting, supplierBrand } = props
    const [isDeletingNow, setIsDeletingNow] = useState(false)

    const ability = defineAbilityFor(getAuthUser())
    const navigate = useNavigate()

    const handleDelete = async () => {
        if (isDeletingNow) return
        setIsDeletingNow(true)

        try {
            await deleteSupplierBrand(supplierBrand.id)
            toastSuccess(`${supplierBrand.name} deleted successfully.`)
            navigate('/suppliers/brands')
        } catch (error: any) {
            console.error('Delete supplier brand error:', error)
        } finally {
            setIsDeletingNow(false)
        }
    }

    return (
        <div className="container card">
            <div className="card-body col-xs-12 row d-flex flex-row justify-content-between mb-5">
                <div className="row flex-row">
                    <h3 className="ps-0 d-inline-flex card-title w-50">
                        {supplierBrand.name}
                    </h3>
                    <div className="pe-0 d-inline-flex justify-content-end w-50 align-items-center">
                        <TooltipWrapper
                            condition={!ability.can('Delete', 'SupplierBrand')}
                            element={
                                <button
                                    className="btn btn-danger me-3"
                                    disabled={
                                        !ability.can('Delete', 'SupplierBrand') ||
                                        isDeletingNow
                                    }
                                    onClick={handleDelete}
                                >
                                    {isDeletingNow ? 'Deleting...' : 'Confirm Delete'}
                                </button>
                            }
                            message="Executive permission required to delete supplier brand"
                        />
                        <button
                            className="btn btn-secondary"
                            onClick={() => setIsDeleting(false)}
                            disabled={isDeletingNow}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
